import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faUniversity, faBrain, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Education.scss';

const education = [
  {
    degree: "M.Sc. in Psychology",
    institution: "J.N. Medical College, Belgaum",
    year: "2019",
    icon: faGraduationCap,
    color: "#8b5cf6",
    description: "Advanced studies in clinical psychology, research methodology, and therapeutic interventions"
  },
  {
    degree: "B.A. in Psychology",
    institution: "K.L.E. Lingaraj College of Arts and Commerce, Belgaum",
    year: "2017",
    icon: faUniversity,
    color: "#ec4899",
    description: "Foundation in psychological theories, human behavior, and research fundamentals"
  }
];

function Education() {
  return (
    <div id="education" className="container">
      <div className="education-container">
        <h1>
          <FontAwesomeIcon icon={faBrain} className="title-icon" />
          Education
        </h1>
        <div className="education-timeline">
          {education.map((edu, index) => (
            <div className="education-card" key={index}>
              <div className="card-header" style={{ borderLeftColor: edu.color }}>
                <div className="icon-wrapper" style={{ backgroundColor: edu.color }}>
                  <FontAwesomeIcon icon={edu.icon} size="2x" />
                </div>
                <div className="header-content">
                  <h2>{edu.degree}</h2>
                  <div className="meta">
                    <FontAwesomeIcon icon={faBookOpen} className="meta-icon" />
                    <span>{edu.institution}</span>
                  </div>
                  <div className="year-badge" style={{ backgroundColor: edu.color }}>
                    {edu.year}
                  </div>
                </div>
              </div>
              <p className="description">{edu.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Education;